import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class AdditionalPaymentOption
 * @property {integer} id
 * @property {Property} property
 * @property {string} name
 * @property {string} name_ar
 * @property {integer} type
 * @property {integer} status
 */
export class AdditionalPaymentOption extends TranslatableModel {
    
    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'name' ];
    }
    
    static get validationModel() {
        
        return {
            name: {
                label: 'PAYMENT_METHOD_NAME_IN_ENGLISH',
                commonLabel: 'Payment Method Name'
            },
            name_ar: {
                label: 'PAYMENT_METHOD_NAME_IN_ARABIC',
                commonLabel: 'Payment Method Name'
            },
            type: {
                label: 'PAYMENT_METHOD_TYPE',
            }
        };
    }

    get TYPE_CASH() {

        return 1;
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
}

AccessorsMutatorsDecorator('id', ...AdditionalPaymentOption.translatableAttributesWithLanguageAliases, 'property', 'property_id', 'type', 'status')(AdditionalPaymentOption);



// WEBPACK FOOTER //
// ./src/pms-api/models/additional-payment-option.model.js